import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopicSelector.css';

export default function JuniorHighVerbs() {
  const navigate = useNavigate();

  return (
    <div className="topic-selector">
      <div className="topic-selector-container">
        <div className="header-with-back">
          <button onClick={() => navigate('/junior-high')} className="back-to-grade-button junior-high">
            חזרה לבחירת נושא
          </button>
          <h2 style={{ paddingTop: '20px' }}>שכבות ז׳-ט׳ - פעלים</h2>
        </div>

        <p className="topic-selector-subtitle">בקרוב יתווספו כאן משחקי פעלים</p>

        <div className="add-topic-info" style={{ marginTop: '20px' }}>
          <h4>פעלים</h4>
          <p>כרגע משחקי הפעלים נמצאים תחת “משחקי דקדוק”.</p>
        </div>
      </div>
    </div>
  );
}

